import { fetchAuthSession } from 'aws-amplify/auth';

// Singleton so concurrent requests share one refresh instead of racing
let _refreshPromise: Promise<string | null> | null = null;

export const tokenService = {
  refreshAccessToken: async (): Promise<string | null> => {
    if (_refreshPromise) return _refreshPromise;

    _refreshPromise = (async () => {
      try {
        const session = await fetchAuthSession({ forceRefresh: true });
        const newAccessToken = session.tokens?.accessToken?.toString();
        if (newAccessToken) {
          localStorage.setItem('accessToken', newAccessToken);
          return newAccessToken;
        }
        return null;
      } catch (error) {
        console.error('Token refresh failed:', error);
        // Return null — let the interceptor show the session modal instead of hard-redirecting
        return null;
      } finally {
        _refreshPromise = null;
      }
    })();

    return _refreshPromise;
  },

  // Treat the token as expired 60 s before it actually expires so we refresh
  // proactively and avoid 401s hitting real API calls
  isTokenExpired: (token: string): boolean => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 < Date.now() + 60_000;
    } catch {
      return true;
    }
  },

  getValidToken: async (): Promise<string | null> => {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;
    if (tokenService.isTokenExpired(token)) {
      return await tokenService.refreshAccessToken();
    }
    return token;
  },
};
